import React, { useEffect, useState } from 'react';
import { adminService, Member } from '../../../services/admin.service';
import styles from './AdminMembersPage.module.scss';

const AdminMembersPage: React.FC = () => {
    const [members, setMembers] = useState<Member[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');

    const token = localStorage.getItem('token') || '';

    const fetchMembers = async () => {
        try {
            const data = await adminService.getMembers(token);
            setMembers(data.members);
        } catch (err: any) {
            setError(err.response?.data?.message || 'Erreur lors du chargement');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchMembers();
    }, []);

    const handleDelete = async (id: string, name: string) => {
        if (!window.confirm(`Supprimer le membre ${name} ?`)) return;
        
        try {
            await adminService.deleteMember(token, id);
            setMessage('Membre supprimé');
            setMembers(members.filter(m => m.id !== id));
        } catch (err: any) {
            setError(err.response?.data?.message || 'Erreur lors de la suppression');
        }
    };

    const handleRoleChange = async (id: string, newRole: string) => {
        try {
            await adminService.updateRole(token, id, newRole);
            setMessage('Rôle mis à jour');
            setMembers(members.map(m => m.id === id ? { ...m, role: newRole } : m));
        } catch (err: any) {
            setError(err.response?.data?.message || 'Erreur lors de la mise à jour du rôle');
        }
    };

    if (loading) return <div>Chargement...</div>;

    return (
        <div className={styles.admin}>
            <h1>Gestion des Membres</h1>
            
            {message && <div className={styles.success}>{message}</div>}
            {error && <div className={styles.error}>{error}</div>}

            <div className={styles.tableWrapper}>
                <table className={styles.table}>
                    <thead>
                        <tr>
                            <th>Nom</th>
                            <th>Email</th>
                            <th>Rôle</th>
                            <th>Date inscription</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {members.map((member) => (
                            <tr key={member.id}>
                                <td>{member.firstname} {member.lastname}</td>
                                <td>{member.email}</td>
                                <td>
                                    <select
                                        value={member.role}
                                        onChange={(e) => handleRoleChange(member.id, e.target.value)}
                                        className={styles.roleSelect}
                                    >
                                        <option value="member">Membre</option>
                                        <option value="admin">Admin</option>
                                    </select>
                                </td>
                                <td>{new Date(member.created_at).toLocaleDateString('fr-FR')}</td>
                                <td>
                                    <button
                                        onClick={() => handleDelete(member.id, `${member.firstname} ${member.lastname}`)}
                                        className={styles.deleteBtn}
                                    >
                                        Supprimer
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AdminMembersPage;
